<div
    class="parent-category"
    [class.active]="isActive()"
    (mouseenter)="onMouseEnterParentCategory()"
    (mouseleave)="onMouseLeaveParentCategory()">
    @if (isMenuEntryWithSubCategories || isAboutMenuEntryWithSubItems) {
        <button
            #menuEntryButton
            [id]="isFirstCategory ? 'collection-button' : 'menu-entry-button'"
            class="category-link label-menu-nav"
            [class.active]="isActive()"
            [class.white]="shouldShowWhiteText()"
            [attr.aria-current]="isCurrentPrimaryEntryActive ? 'true' : null"
            aria-haspopup="true"
            [attr.aria-controls]="'sub-menu-' + menuEntryNameHtmlClean"
            [attr.aria-expanded]="isActive()"
            (click)="toggleEntry($event)"
            (keydown.escape)="closeMenu()"
            ><span [innerHTML]="menuEntry?.name || menuAboutEntry?.label"></span
        ></button>
        <div
            #subMenu
            [id]="'sub-menu-' + menuEntryNameHtmlClean"
            class="sub-menu"
            [class.show]="isActive()"
            aria-haspopup>
            <h-menu-sub-category
                [menuEntry]="menuEntry"
                [menuAboutEntry]="menuAboutEntry"
                (closeSubMenu)="closeMenu()"
                [isLastCategory]="isLastCategory">
            </h-menu-sub-category>
        </div>
    } @else {
        <h-menu-bar-link
            #menuEntryLink
            id="menu-entry-link"
            [anchorId]="isFirstCategory ? 'collection-button' : 'menu-link'"
            [menuEntry]="menuEntry"
            [menuAboutEntry]="menuAboutEntry"
            [menuLinkLevel]="'menu-link-lvl1'"
            class="menu-link label-menu-nav"
            [class.active]="isActive()"
            [attr.aria-current]="isCurrentPrimaryEntryActive ? 'true' : null"
            (menuLinkClicked)="closeMenu()"></h-menu-bar-link>
    }
</div>
